export default __webpack_public_path__ + "static/media/chartImage.6eab02e4.png";